import { useLang } from "@/context/LanguageContext";
import { Reveal, ImageReveal } from "@/components/Reveal";
import { SectionLabel, Marquee } from "@/components/Editorial";
import { PageHead, CTABand } from "@/components/Shared";
import { IMAGES } from "@/data/config";

const sectionImages = [IMAGES.arch1, IMAGES.detail, IMAGES.studioInterior, IMAGES.studioWide];

export default function About() {
  const { t } = useLang();
  return (
    <>
      <PageHead label={t.about.label} title={t.about.title} lead={t.about.lead} />

      <section className="bg-petal" data-testid="about-sections">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
          {t.about.sections.map((s, i) => (
            <div key={s.label} className={`grid items-center gap-10 border-b border-onyx/10 py-20 md:grid-cols-2 md:py-28 ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
              <ImageReveal src={sectionImages[i % sectionImages.length]} alt={s.title} className="aspect-[4/3]" />
              <div className={i % 2 ? "md:pr-12" : "md:pl-12"}>
                <SectionLabel>{s.label}</SectionLabel>
                <Reveal><h2 className="mt-6 font-serif text-5xl leading-[0.98] md:text-6xl">{s.title}</h2></Reveal>
                <p className="mt-6 max-w-md font-sans text-lg leading-relaxed text-onyx/70">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Marquee />

      <section className="bg-blush/40" data-testid="about-founder">
        <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32">
          <SectionLabel>{t.about.founderLabel}</SectionLabel>
          <h2 className="mt-8 max-w-3xl font-serif text-5xl leading-[1] italic md:text-6xl">{t.about.founderTitle}</h2>
          <p className="mt-8 max-w-xl font-sans text-base italic text-onyx/50">{t.about.founderBody}</p>
        </div>
      </section>

      <CTABand />
    </>
  );
}
